import * as React from "react";
import { forwardRef } from "react";
const SvgMaturity = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("g", { id: "Icons / 16" }, /* @__PURE__ */ React.createElement("path", { id: "Union", fillRule: "evenodd", clipRule: "evenodd", d: "M15 3C15 2.44772 14.5523 2 14 2H10V5H7V8H4V11H1V14C1 14.5523 1.44772 15 2 15H14C14.5523 15 15 14.5523 15 14V3Z", stroke: "currentColor", strokeWidth: 2, strokeLinejoin: "round" })));
const ForwardRef = forwardRef(SvgMaturity);
export default ForwardRef;
